<template>
  <div class="card-curvey login-form">
    <v-form v-model="valid" ref="signupForm">
      <div class="login-desc">
        <h2>Sign up and create your first bot</h2>
        <p>Let us know more about your business</p>
      </div>
      <v-form v-model="valid" ref="signupForm" class="mt-5 text-xs-left">
        <Label>Enter your first name</Label>
        <v-text-field
          outline
          v-model="first_name"
          name="first_name"
          placeholder="First name"
          type="text"
          flat
          :rules="[(v) => !!v || 'First name is required']"
        ></v-text-field>
        <Label>Enter your last name</Label>

        <v-text-field
          outline
          v-model="last_name"
          name="last_name"
          placeholder="Last name"
          type="text"
          flat
          :rules="[(v) => !!v || 'Last name is required']"
        ></v-text-field>
        <Label>Enter your email address</Label>

        <v-text-field
          outline
          v-model="email"
          name="email"
          placeholder="EMail"
          type="email"
          flat
          :rules="[(v) => !!v || 'Email or user name is required']"
        ></v-text-field>
        <label>Enter your Password</label>
        <v-text-field
          outline
          :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          v-model="password"
          name="password"
          placeholder="Password"
          :rules="[(v) => !!v || 'Password is required']"
        ></v-text-field>
        <Label>Enter Bot name</Label>
        <v-text-field
          outline
          v-model="bot_name"
          name="bot_name"
          placeholder="Bot name"
          type="text"
          flat
          :rules="[(v) => !!v || 'Bot name is required']"
        ></v-text-field>

        <Label>Add channels</Label>
        <v-autocomplete
          v-model="channels"
          :items="channelsList"
          placeholder="Add Channels"
          :rules="[(v) => !!v || 'Bot channels is required']"
          multiple
          outline
          flat
        ></v-autocomplete>

        <Label>Add industry</Label>
        <v-autocomplete
          v-model="industry"
          :items="industryList"
          placeholder="Add industry"
          :rules="[(v) => !!v || 'industry is required']"
          outline
          flat
        ></v-autocomplete>

        <Label>Add languages</Label>
        <v-autocomplete
          v-model="lang"
          :items="languageList"
          item-text="name"
          item-value="code"
          placeholder="Add languages"
          :rules="[(v) => !!v || 'Languaeg is required']"
          multiple
          outline
          flat
        ></v-autocomplete>

        <div v-if="env === 'demos'">
          <Label>Activation code</Label>
          <v-text-field
            outline
            v-model="activation_code"
            name="activation_code"
            placeholder="Activation code"
            type="text"
            flat
            :rules="[(v) => !!v || 'Activation code is required']"
          ></v-text-field>
        </div>

        <v-btn
          @click="signUp"
          block
          large
          round
          color="primary"
          :loading="loader"
          >Register</v-btn
        >
        <v-btn block large round flat color="secondary" to="/login/"
          >Back</v-btn
        >
      </v-form>
      <div v-if="wrongCredentials === true" class="text-xs-center white--text">
        Invalid User Name or Password
      </div>
    </v-form>
  </div>
</template>

<script>
import env from "../utils/env";
import isoLangs from "../utils/lang-iso";
export default {
  data: () => ({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    bot_name: "",
    channels: [],
    industry: "",
    lang: [],
    activation_code: "",
    valid: false,
    wrongCredentials: false,
    showPassword: false,
    channelsList: ["Facebook", "Web", "WhatsApp", "Twitter", "Skype"],
    industryList: [
      "Banking",
      "Telecommunication",
      "Airline",
      "E Services",
      "Automotive",
      "Health Care",
      "Other",
    ],
    loader: false,
    // languageList: ['Standard Arabic', 'English US', 'English UK']
  }),
  methods: {
    signUp() {
      if (this.$refs.signupForm.validate()) {
        this.loader = true;
        const store = this.$store;
        this.$http_auto_provision
          .post("api/auth/sign-up", {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            password: this.password,
            bot_name: this.bot_name,
            channels: this.channels,
            industry: this.industry,
            lang: this.lang,
            activation_code: this.activation_code,
          })
          .then((response) => {
            this.loader = false;
            store.dispatch("setSnackbar", {
              text: "Account registered successfully ",
              color: "primary",
              status: true,
            });
            setTimeout(() => {
              this.$router.push("/login");
            }, 1000);
          })
          .catch((error) => {
            this.loader = false;
            this.wrongCredentials = true;
          });
      }
    },
  },
  computed: {
    languageList() {
      return isoLangs;
    },
    env() {
      return env.CURRENT_ENV;
    },
  },
};
</script>
<style scoped>
.login-img-wrapper {
  position: fixed;
  top: 0;
  right: 0;
}
</style>
